(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("sbBffIntegration"), require("sbInternalMsgBus"), require("sbMsgBusModule"));
	else if(typeof define === 'function' && define.amd)
		define("sbBetslipLib", ["sbBffIntegration", "sbInternalMsgBus", "sbMsgBusModule"], factory);
	else if(typeof exports === 'object')
		exports["sbBetslipLib"] = factory(require("sbBffIntegration"), require("sbInternalMsgBus"), require("sbMsgBusModule"));
	else
		root["sbBetslipLib"] = factory(root["sbBffIntegration"], root["sbInternalMsgBus"], root["sbMsgBusModule"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__2__, __WEBPACK_EXTERNAL_MODULE__3__, __WEBPACK_EXTERNAL_MODULE__131__) {
return 